"use client";
import { cn } from "@/lib/helpers/utils";
import { Button } from "@/components/ui/button";
import { setCookie } from "@/lib/helpers/functions";
import { useTheme } from "@/app/providers/QuranThemeProvider";

const ColorSchemesSelector = ({ className }: { className?: string }) => {
  const { colorScheme, setColorScheme } = useTheme();

  const colorValues = [
    { name: "", val: "gray" },
    { name: "green-", val: "#16a34a" },
    { name: "violet-", val: "#7c3bed" },
    { name: "yellow-", val: "#facc15" },
    { name: "orange-", val: "#f97415" },
    { name: "rose-", val: "#e11d48" },
    { name: "blue-", val: "#3b82f6" },
    { name: "leaf-", val: "#49a014" },
    { name: "sand-", val: "#bf7340" },
    { name: "pink-", val: "#e7999f" },
    { name: "slate-", val: "#c0bfbc" },
    { name: "ruby-", val: "#9e2929" },
    { name: "teal-", val: "#0f7f71" },
    { name: "autumn-", val: "#7e950c" },
    { name: "crimson-", val: "#953c6c" },
    { name: "sky-", val: "#3e7098" },
    { name: "skin-", val: "#8e6a4c" },
    { name: "plum-", val: "#b75389" },
    { name: "darklime-", val: "#5f9100" },
    { name: "cyan-", val: "#00a2c7" },
    { name: "amber-", val: "#ffc53d" },
    { name: "red-", val: "#ff0000" },
    { name: "ink-", val: "#262fca" },
    { name: "purple-", val: "#553e9c" },
  ];
  let handleClick = (name: string) => {
    setCookie("color-scheme", name, 365);
    setColorScheme(name);
  };

  return (
    <div
      className={cn(
        "grid grid-cols-7 md:grid-cols-8 justify-center pt-4",
        className,
      )}
    >
      {colorValues.map((e) => {
        let isActive = colorScheme == e.name;
        return (
          <Button
            key={e.name}
            className={cn(
              "rounded-lg p-0 h-8 w-8 ",
              isActive ? "border-2" : "border-0",
            )}
            onClick={() => handleClick(e.name)}
            variant={isActive ? "outline" : "ghost"}
          >
            <div
              className="h-6 w-6 border-0 rounded-md"
              style={{
                background: e.val,
              }}
            />
          </Button>
        );
      })}
    </div>
  );
};
export default ColorSchemesSelector;
